<template>
  <div class="ccontainer">
    <div class="content">
      <div
        class="post-options dropdown-container"
        @mouseleave="showOptions = false"
      >
        <div class="dropdown-fake-container" :class="{ active: showOptions }">
          <div
            class="dropdown-btn icon fa-lg fas"
            :class="{ active: showOptions }"
            aria-hidden="true"
            @click="showOptions = !showOptions"
          ></div>
        </div>
        <div v-if="showOptions" class="dropdown-items">
          <div class="item" @click="raiseShowOptions">
            {{ $t("report.title") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import("../../../../public/js/lib/FontAwesomeKit"); // <--- importing FontAwesome icons

export default {
  data() {
    return {
      showOptions: false,
    };
  },
  methods: {
    raiseShowOptions() {
      this.$emit("showOptions");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../styles/variables.scss";

.ccontainer {
  display: flex;

  .content {
    position: relative;
    margin: auto;
    width: 21.31px;
    height: 20px;
  }
}

.post-options {
  align-self: center;
  .icon {
    width: 20px;
    height: 20px;
    padding-bottom: 0.75em;
    padding-inline: 0.5em;
    background-image: url("/img/btn/three-dots.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
}

.dropdown-container {
  position: absolute;
  right: 0%;

  .item,
  .dropdown-fake-container.active {
    min-width: 150px;
    text-align: center;
    color: inherit;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: bold;
    padding-block: 0.75em;
    flex-grow: 1;
    transition: background-color 0.2s ease-in-out;

    &.router-link-active {
      background-color: lighten(#000000, 60);
    }

    &:hover {
      background-color: lighten(#000000, 75);
    }
  }

  .item {
    display: block;
  }

  .dropdown-fake-container {
    display: flex;
    justify-content: end;

    &.active {
      padding-block: 0em;
      background-color: unset !important;
    }
  }

  .dropdown-btn {
    cursor: pointer;

    &.active {
      cursor: default;
    }
  }

  .dropdown-items {
    position: absolute;
    top: 100%;
    right: 0%;
    z-index: 9;
    background: lighten(#000000, 90);
  }
}
</style>
